import * as React from "react";
import type { SVGProps } from "react";
const SvgWiFi = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.124 9.32A10.96 10.96 0 0 1 12 6c3.087 0 5.876 1.27 7.875 3.32l.698.716 1.432-1.396-.698-.716A12.96 12.96 0 0 0 12 4a12.96 12.96 0 0 0-9.308 3.924l-.698.716 1.432 1.396zm2.71 2.957A6.98 6.98 0 0 1 12 10a6.98 6.98 0 0 1 5.167 2.277l.675.738 1.476-1.35-.675-.738A8.98 8.98 0 0 0 12 8a8.98 8.98 0 0 0-6.642 2.927l-.675.738 1.476 1.35zM12 14c-.963 0-1.819.452-2.37 1.159l-.614.789-1.578-1.229.615-.789A5 5 0 0 1 12 12c1.604 0 3.033.757 3.946 1.93l.615.789-1.578 1.229-.615-.79A3 3 0 0 0 12 14m2 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgWiFi;
